export const pickerOptions = {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("common.components.datePicker.today"),
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: this.$t("common.components.datePicker.yesterday"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  }
};
